<template>
  <nav
    class="navbar sticky-top navbar-expand-sm navbar-dark bg-black"
    role="navigation"
  >
    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
      <router-link to="/" class="navbar-brand mr-auto">
        <img width="45" height="45" src="logo192.png" alt />
        <img width="170px" class="ml-2" src="farmagirasol2.png" alt />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTop"
        aria-controls="navbarTop"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse"
        id="navbarTop"
        :class="{ show: isNavOpen }"
      >
        <ul class="navbar-nav mr-auto"></ul>
        <ul class="nav navbar-nav">
          <router-link
            to="/"
            tag="li"
            exact
            class="nav-item"
            active-class="active"
          >
            <a class="nav-link">Inicio</a>
          </router-link>
          <router-link
            to="/login"
            tag="li"
            v-if="!isLoggedIn"
            class="nav-item"
            active-class="active"
          >
            <a class="nav-link">Ingresar</a>
          </router-link>
          <li v-if="isLoggedIn" class="li-pointer nav-item">
            <a @click="logout" class="nav-link"
              >Cerrar sesión ({{ userEmail }})</a
            >
          </li>
          <router-link
            to="/register"
            tag="li"
            v-if="!isLoggedIn"
            class="nav-item"
            active-class="active"
          >
            <a class="nav-link">Registrarse</a>
          </router-link>
          <li>
            <router-link
              to="/orders"
              tag="li"
              v-if="isLoggedIn"
              class="nav-item"
              active-class="active"
            >
              <a class="nav-link">Mis órdenes</a>
            </router-link>
          </li>
          <router-link
            to="/questions"
            tag="li"
            exact
            class="nav-item"
            active-class="active"
          >
            <a class="nav-link">
              Preguntas
              <span class="badge-color badge badge-pill badge-secondary"
                >Nuevo</span
              >
            </a>
          </router-link>
          <template v-if="rate">
            <li class="nav-link">
              Tasa:
              {{
                rate
                  | currency("Bs.", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                    symbolOnLeft: true,
                    spaceBetweenAmountAndSymbol: true,
                  })
              }}
            </li>
          </template>
          <li>
            <router-link :event="cartEmpty ? '' : 'click'" to="/cart">
              <div id="ex4">
                <span
                  style="font-size: 25px"
                  class="p1 fa-stack has-badge"
                  :data-count="numItems"
                >
                  <i
                    class="p3 icon-color fa fa-shopping-cart fa-stack-1x xfa-inverse"
                  ></i>
                </span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- /.container -->
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      isNavOpen: false,
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "cartValue",
      "currentUser",
      "cartItemList",
      "rate",
    ]),
    numItems() {
      return this.cartItemList.reduce((total, item) => {
        total += item.count;
        return total;
      }, 0);
    },
    userEmail() {
      return this.isLoggedIn ? this.currentUser.user.email : "";
    },
    priceUSD() {
      if (this.rate) return this.cartValue / this.rate;
      else return "";
    },
    cartEmpty() {
      return !this.cartItemList.length;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    toggleNavbar() {
      this.isNavOpen = !this.isNavOpen;
    },
    goToCart() {
      if (!this.cartEmpty) this.$router.push("/cart");
    },
  },
};
</script>


<style scoped lange="sass">
.navbar-btn a {
  color: white;
}

.li-pointer {
  cursor: pointer;
}

.li-pointer:hover {
  cursor: pointer;
}

.bg-black {
  background-color: black !important;
}

#ex4 .p1[data-count]:after {
  position: absolute;
  right: 10%;
  top: 8%;
  content: attr(data-count);
  font-size: 50%;
  padding: 0.2em;
  border-radius: 50%;
  line-height: 1em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 1em;
}

.icon-color {
  color: rgb(226, 118, 28);
}

.badge-color {
  background-color: rgb(226, 118, 28) !important;
}
</style>
